<template>
    <div>
        <div class="FPS-logo">
            <img src="@/assets/image/user/FPS.png" />
        </div>
        <div class="qr-code-center">
            <div class="kongge"></div>
            <div class="time">
                {{ $t("二維碼有效時間倒計時  ") }}
                <span style="color: #E84935;">{{countdownText}}</span>
            </div>
            <div class="qr-code-box">
                <canvas v-if="!timeOver" id="payCodeCanvas" className="qr-code" />
                <!-- <img v-else src="@/assets/image/user/timeOver.png" /> -->
                <div v-else class="time-over">
                    <div class="info">{{ $t("二維碼已失效,即将跳转页面") }} <br>{{ overTime }}</div>
                    <!-- <div>{{ overTime }}</div> -->
                </div>
            </div>
            <div class="money-box">
                <span class="name">HK$</span>
                <span class="num">{{ payMoney }}</span>
            </div>
            <div class="payInfo">
                <div class="info">
                    {{ $t("交易完成前請不要關閉此頁面") }}
                </div>
            </div>
            <div class="useInfoBox" @click="showGuide">
                {{ $t("使用指南") }}
                <img src="@/assets/icons/user-FPS.png" />
            </div>
        </div>
        <div class="btnBox">
            <div class="download" @click="downloadBtn">{{ $t("下載圖片") }}</div>
            <div class="cancel" @click="cancelPay">{{ $t("取消支付") }}</div>
        </div>
        <div class="guide" v-if="isshowGuide" @click="cancelGuide">
            <img v-if="langEnv == 3" src="@/assets/image/user/guideC.png" />
            <img v-if="langEnv == 2" src="@/assets/image/user/guideE.png" />
        </div>
    </div>
</template>
<script>
import Logo from '@/assets/image/user/FPS.png';
import { drawPayCode, qrcode } from '@/utils/paycode.js';
import mixins from "@/utils/mixins.js"
import {
  closeOrder
} from "@/api/user.js"
export default {
    name: 'qrCodePage',
    mixins: [mixins],
    data () {
        return {
            payMoney: 0,
            isshowGuide: false,
            payTime: "",
            countdownText: "00:00", // 倒计时显示文本
            timer: null, // 定时器标识，用于销毁时清除
            timeOver: false,
            overTime: 3,
            timer1: null,
            langEnv: 2
        }
    },
    created () {
        
    },
    mounted() {
        console.log(this.$route.query)
        if (this.$route.query.qrcode) {
            if (!this.timeOver) {
                this.updateQrcode(this.$route.query.qrcode)
            }
            this.payMoney = (Math.round(this.$route.query.payPrice/100 * 100) / 100).toFixed(2);
            this.payTime = this.$route.query.payTime
            this.langEnv = localStorage.getItem("langEnv") || 2
            // 1. 初始化时立即计算一次（避免延迟）
            this.calculateCountdown();
            // 2. 启动定时器，每秒更新一次倒计时
            this.timer = setInterval(() => {
                this.calculateCountdown();
            }, 1000);
        } else {
            this.$toast(this.$t("支付不正确，即将返回"))
            setTimeout(() => {
                history.go(-1)
            }, 3000)
        }
    },
    methods: {
        padZero(num) {
            return num < 10 ? `0${num}` : `${num}`;
        },
        calculateCountdown() {
            try {
                // 1. 解析payTime为UTC时间戳（Z表示UTC时区，统一时区避免误差）
                const targetTime = new Date(this.payTime).getTime();
                // 2. 获取当前UTC时间戳（和目标时间时区一致）
                const currentTime = new Date().getTime();
                // 3. 计算时间差（毫秒）→ 转成秒（向下取整）
                const diffSeconds = Math.floor((targetTime - currentTime) / 1000);
                
                // 4. 处理边界：时间差≤0 → 倒计时结束
                if (diffSeconds <= 0) {
                    this.countdownText = "00:00";
                    this.timeOver = true
                    this.overI()
                    // 清除定时器（避免无效循环）
                    if (this.timer) {
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                    return;
                }

                // 5. 秒数转分钟:秒
                const minutes = Math.floor(diffSeconds / 60); // 总分钟数
                const seconds = diffSeconds % 60; // 剩余秒数

                // 6. 格式化并更新显示
                this.countdownText = `${this.padZero(minutes)}:${this.padZero(seconds)}`;
            } catch (e) {
                console.error("倒计时计算失败：", e);
                this.countdownText = "时间格式错误";
            }
        },
        overI() {
            this.timer1 = setInterval(async () => {
                if (this.overTime <= 0) {
                    clearInterval(this.timer1);
                    this.timer1 = null;
                    await closeOrder({ id: this.$route.params.orderNo })
                    this.$router.push(
                    "/payResult?type=fail" +
                    "&pay=" + 1 +
                    "&orderId=" +
                    this.$route.params.orderNo +
                    `&price=${this.payMoney}` +
                    "&message=訂單失效"
                  )
                } else {
                    this.overTime = this.overTime - 1
                }
            }, 1000);
        },
        updateQrcode(code) {
			const text = code.replace(/^[\s\u3000]+|[\s\u3000]+$/g, '');
			// eslint-disable-next-line no-undef
			const qr = this.createQrcode(text, '8', 'M', 'Byte', 'UTF-8');
			const canvas = document.getElementById('payCodeCanvas');
			console.log(document.getElementById('payCodeCanvas'));
			const ctx = canvas.getContext('2d');
			var logo = document.createElement('img');

			logo.src = Logo;
			logo.onload = () => {
				canvas.width = 279;
				canvas.height = 279;
				ctx.setTransform(1, 0, 0, 1, 0, 0);
				ctx.clearRect(0, 0, canvas.width, canvas.height);
				drawPayCode(qr, canvas, 7, logo, true);
			};
		},
        createQrcode(text, typeNumber, errorCorrectionLevel, mode, mb) {
			qrcode.stringToBytes = qrcode.stringToBytesFuncs[mb];
			if (typeNumber === 0) {
				typeNumber = this.suggestTypeNumber(text);
			}
			const qr = qrcode(typeNumber || 4, errorCorrectionLevel || 'M');
			qr.addData(text, mode);
			qr.make();
			return qr;
		},
        showGuide() {
            this.isshowGuide = true
        },
        cancelGuide() {
            this.isshowGuide = false
        },
        downloadBtn() {
            if (this.timeOver) {
                this.$toast(this.$t("二维码已失效"))
                return false
            }
            try {
                // 1. 获取Canvas元素（Vue2中也可通过ref获取，更推荐）
                const canvas = document.getElementById("payCodeCanvas");
                if (!canvas) {
                    this.$toast(this.$t("未找到二维码画布，请重试！"))
                    return;
                }

                // 2. 检查Canvas是否有内容（避免下载空白图片）
                const ctx = canvas.getContext("2d");
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const hasContent = imageData.data.some((pixel) => pixel !== 0);
                if (!hasContent) {
                    this.$toast(this.$t("二维码画布为空，请先生成二维码！"))
                    return;
                }

                // 3. 将Canvas转为图片URL（PNG格式，如需JPG可改image/jpeg）
                const imageUrl = canvas.toDataURL("image/png");

                // 4. 创建隐藏的a标签触发下载
                const link = document.createElement("a");
                link.href = imageUrl;
                // 设置下载文件名（后缀需和格式匹配）
                link.download = "付款二维码.png";
                // 解决部分浏览器无法触发click的问题
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();

                // 5. 清理临时元素
                document.body.removeChild(link);
                this.$toast(this.$t("二维码图片下载成功！"))
            } catch (e) {
                // 捕获跨域、Canvas无内容等异常
                this.$toast(this.$t("下载失败!"))
            }
        },
        cancelPay() {
            history.go(-1)
        }
    },
    beforeDestroy() {
        // 组件销毁时清除定时器，避免内存泄漏
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        if (this.timer1) {
            clearInterval(this.timer1);
            this.timer1 = null;
        }
    },
}
</script>
<style lang="scss" scoped>
.FPS-logo{
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 24px;
    margin-bottom: 20px;
    img{
        width: 56px;
        height: 56px;
    }
}
.qr-code-center{
    width: 327px;
    height: 503px;
    background: #FFFFFF;
    box-shadow: 0px 4px 24px 0px rgba(0,0,0,0.15) !important;
    border-radius: 16px 16px 16px 16px;
    margin-left: 24px;
    .kongge{
        width: 100%;
        height: 24px;
    }
    .time{
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
        font-weight: 500;
        font-size: 15px;
        color: rgba(0,0,0,0.9);
    }
    .qr-code-box{
        display: flex;
        justify-content: center;
        .qr-code{
            width: 279px;
            height: 279px;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #EBEBEB;
        }
        .time-over{
            width: 279px;
            height: 279px;
            background: url("~@/assets/image/user/timeOver.png") no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            // flex-wrap: wrap;
            align-items: center;
            .info{
                font-weight: bold;
                font-size: 16px;
                color: #1A1A1A;
                line-height: 24px;
                text-align: center;
            }
        }
    }
    .money-box {
        display: flex;
        justify-content: center;
        align-items: flex-end; /* 核心：Flex子元素底部对齐 */
        color: #1A1A1A;
        margin-top: 24px;
        /* 移除无效的 vertical-align: bottom */
        
        .name {
            // font-size: 20px;
            /* 可选：微调文字底部间距，避免视觉上的偏移 */
            // margin-bottom: 1px; 
            font-weight: 800;
        }
        
        .num {
            font-size: 30px;
            font-weight: 800;
            /* 可选：消除数字可能的基线偏移（部分字体需要） */
            line-height: 1;
        }
    }
    .payInfo{
        display: flex;
        justify-content: center;
        margin-top: 16px;
        margin-bottom: 16px;
        .info{
            width: 279px;
            font-weight: 400;
            font-size: 13px;
            color: #999999;
            line-height: 20px;
            text-align: center;
        }
    }
    .useInfoBox{
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        img{
            width: 13px;
            height: 13px;
            margin-left: 5px;
        }
    }
}
.btnBox{
    width: 100%;
    height: 90px;
    background: #FFFFFF;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: flex-start;
    .download{
        width: 168px;
        height: 44px;
        line-height: 44px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #90D12E;
        font-size: 15px;
        font-weight: 500;
        color: #71B800;
        text-align: center;
        margin-left: 16px;
        margin-top: 10px;
    }
    .cancel{
        width: 168px;
        height: 44px;
        line-height: 44px;
        border-radius: 8px 8px 8px 8px;
        font-size: 15px;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        background: #90D12E;
        margin-left: 8px;
        margin-top: 10px;
    }
}
.guide{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background: rgba(0,0,0,0.6);
    img{
        width: 100%;
        height: 690px;
        margin-top: 72px;
    }
}
</style>